/** @prettier */

import React from 'react';
import Helmet from 'react-helmet';
import config from '../../config';

const title = `Surf Cams - Watch Live Beach Webcams in HD - Surfline`;
const description = `Surfline’s global network of surf cams includes multiple views of spots, pinch-to-zoom effects and a host of new locations. Strategically placed, these real-time, HD-quality surf checks allow you to view waves and beach conditions from Manasquan to Malibu, Nazare to Newport, Oahu’s Seven Mile Miracle to Waco’s fresh-water skatepark, and hundreds of world-famous surf breaks in between.`;
const link = [{ rel: 'canonical', href: `${config.homepageSEOUrl}surf-cams` }];

const meta = [
  { name: 'description', content: description },
  { property: 'og:title', content: title },
  { property: 'og:url', content: link },
  { property: 'og:image', content: config.meta.og.image },
  { property: 'og:description', content: description },
  { property: 'twitter:title', content: title },
  { property: 'twitter:url', content: link },
  { property: 'twitter:image', content: config.meta.twitter.image },
  { property: 'twitter:description', content: description },
];

if (config.robots) {
  meta.push({
    name: 'robots',
    content: config.robots,
  });
}

const SurfCamsHelmet = () => <Helmet title={title} meta={meta} link={link} />;

export default SurfCamsHelmet;
